import { ConcreteEncodable } from "./ConcreteEncodable";

import { PlatformProfileImplEncoder } from "../../encoder/PlatformProfileImplEncoder";

import * as CubiqTS from "../../index";
import { PlatformProfile } from "../PlatformProfile";

export class PlatformProfileImpl extends ConcreteEncodable implements PlatformProfile {
  public static enType: string = "com.bcdfx.model.PlatformProfileImpl";

  /*FID=1*/
  public profileId: string;
  /*FID=2*/
  public profileName: string;
  /*FID=3*/
  public isUserProfileFg: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = PlatformProfileImplEncoder.Instance;
    this.setEncodableType(PlatformProfileImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "PlatformProfileImpl[" +
      "profileId=" +
      this.profileId +
      "profileName=" +
      this.profileName +
      "isUserProfileFg=" +
      this.isUserProfileFg +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
